<app-data-list-command
    [filters]="filters()"
    [(filtersToApply)]="filtersToApply"
    sidenavclass="p-t-3xl"
    data-testid="progress-payments-tab">
    <div fxLayoutAlign="end">
        <button mat-icon-button [mat-menu-trigger-for]="more" [attr.aria-label]="'a11y.common.more' | translate" data-testid="progress-payments-tab-actions">
            <mat-icon aria-hidden="true">more_vert</mat-icon>
        </button>
    </div>
    <div class="cipo--height--full cipo-bg--white" cipoCommandContent>
        @if (viewType() === "table") {
            <cipo-paged-data-list
                [options]="tableOptions()"
                [tableData]="tableData()"
                [tableColumns]="tableColumns()"
                (rowClicked)="openDocument($event)"
                data-testid="progress-payments-tab-table" />
        } @else {
            <div fxLayout="row wrap" fxLayoutGap="12px">
                @for (item of tableData(); track $index) {
                    <div
                        fxFlex="32"
                        fxFlex.lt-xl="48"
                        fxFlex.lt-lg="100"
                        fxLayout="column"
                        (click)="openDocument(item)"
                        class="cipo-bg--primary-50 cipo--border--solid m-b-md p-a-sm"
                        [attr.data-testid]="'progress-payments-tab-item-' + item.id">
                        @for (column of tableColumns(); track column.id) {
                            <div fxLayout fxLayoutAlign="stretch start">
                                <p fxFlex>{{ column.displayName | translate }}</p>
                                <p fxFlex [attr.data-testid]="'progress-payments-tab-item-value-' + column.name">
                                    @switch (column.displayFormatId) {
                                        @case (DISPLAY_FORMATS.Date) {
                                            {{
                                                $any(item[column.name])
                                                    | itvDateTimeWithRestrictions: column.restrictions
                                            }}
                                        }
                                        @case (DISPLAY_FORMATS.Number) {
                                            {{
                                                $any(item[column.name])
                                                    | itvNumberWithFormattings
                                                        : column.formattings
                                                        : column.restrictions
                                                        : userStore.currency()
                                            }}
                                        }
                                        @case (DISPLAY_FORMATS.Status) {
                                            <cipo-state
                                                [name]="item.state_name.label"
                                                [bgColor]="item.state_name.bgColor"
                                                [textColor]="item.state_name.color"
                                                data-testid="progress-payments-tab-item-state" />
                                        }
                                        @default {
                                            {{ item[column.name] }}
                                        }
                                    }
                                </p>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
</app-data-list-command>

<mat-menu #more="matMenu">
    <button mat-menu-item [matMenuTriggerFor]="displayType">
        <mat-icon class="material-symbols-outlined">display_settings</mat-icon>
        <span>{{ "actions.displayType" | translate }}</span>
    </button>
</mat-menu>

<mat-menu #displayType="matMenu">
    <button mat-menu-item [disabled]="viewType() === 'table'" (click)="setViewType('table')">
        <mat-icon class="material-symbols-outlined">table_rows_narrow</mat-icon>
        <span>{{ "actions.listView" | translate }}</span>
    </button>
    <button mat-menu-item [disabled]="viewType() === 'grid'" (click)="setViewType('grid')">
        <mat-icon class="material-symbols-outlined">grid_view</mat-icon>
        <span>{{ "actions.gridView" | translate }}</span>
    </button>
</mat-menu>
